<template>
  <div class="content">
    <div class="content-full">
      <div class="page-container">
        <div class="page-back">
          <ul class="breadcrumb">
            <li>
              <a href="javascript:void(0);" @click="callCancelDialog"><v-icon name="back" /><span>{{ $t('敏感词监控') }}</span></a>
            </li>
          </ul>
        </div>
        <h2 class="sub-page-title">
          {{ getCurrentTitle }}
        </h2>
        <s v-if="loading" class="loading" />
        <div v-else class="page-wrapper group-form">
          <v-form kind="desc">
            <v-form-item :label="$t('规则名')" name="ruleName" :required="$t('必填')" :error="ruleNameErr ? $t('规则名') : ''">
              <v-input ref="ruleName" v-model="ruleName" :limit="MAX_RULE_NAME_LENGTH" :placeholder="$t('请输入规则名')" autofocus />
            </v-form-item>

            <v-form-item :label="$t('敏感词')" class="sensitive-words" name="sensitiveWords" :required="$t('必填')"
              :error="sensitiveWordsErr ? $t('敏感词不能为空') : ''"
>
              <div class="form-item-wrapper">
                <word-input :value="sensitiveWords" @input="sensitiveWordsChange" />
              </div>
            </v-form-item>

            <v-form-item v-if="currentType !== 3" :label="$t('监控消息类型')" name="msgType" :required="$t('必填')" :error="monitorTypesErr ? $t('请选择') : ''">
              <v-checkbox-group v-model="monitorTypeArray">
                <template v-for="(item, index) in monitorTypes">
                  <v-checkbox :key="index" :value="item.value">
                    {{ $t(item.label) }}
                  </v-checkbox>
                  <span :key="index + 'space'" class="group-form__space" />
                </template>
              </v-checkbox-group>
            </v-form-item>
            <v-form-item :label="$t('监控对象')" name="monitorTarget" :required="$t('必填')" :error="staffSelectedErr ? $t('请选择') : ''">
              <select-staffs
                :prop-staff-selected="staffSelected"
                :prop-staff-org-list="staffOrgList"
                :staff-selected-err="staffSelectedErr"
                @change="staffSelectedChange"
                @select="showSelect"
                @selectDepart="showDepart"
                @changeSelected="changeSelected"
                @changeOrg="changeOrg"
              />
            </v-form-item>
            <v-form-item class="sensitive-degree-radio" :label="$t('告警程度')" name="sensitiveDegreeRadio">
              <div class="sensitive-degree-value-wrapper">
                <v-icon v-tip:tips.hover class="sensitive-degree-radio__tip" name="help" />
                <v-tip ref="tips" kind="large" placement="top-start" clazz="sensitive-degree-radio">
                  <div class="sensitive-degree-radio__content">
                    <div class="content-part">
                      <div class="content-part__title">
                        {{ $t('仅留存记录') }}
                      </div>
                      <div class="content-part__img content-part__img1" />
                    </div>
                    <div class="content-part">
                      <div class="content-part__title">
                        {{ $t('消息拦截') }}
                      </div>
                      <div v-if="currentType === 3" class="content-part__img content-part__img2" />
                      <div v-else class="content-part__img content-part__img3" />
                      <div class="content-part__footer">
                        {{ $t('客户收到发送失败提示，客服收不到消息') }}
                      </div>
                    </div>
                    <div v-if="currentType === 3" class="content-part">
                      <div class="content-part__title4">
                        {{ $t('消息替换过滤为*') }}
                      </div>
                      <div class="content-part__img content-part__img4" />
                      <div class="content-part__footer4">
                        {{ $t('客服收到消息，其中命中的敏感词替换为*') }}
                      </div>
                    </div>
                  </div>
                </v-tip>
                <sensitive-degree-edit v-model="sensitiveDegreeRadio" :current-type="currentType" />
              </div>
            </v-form-item>
          </v-form>
          <div class="group-form__contral-bar">
            <v-button :disabled="submitOrCancelBtnClick || (isEdit && !isEdited)" status="primary"
              @click="saveAndSubmit(1)"
>
              {{ $t('保存并应用') }}
            </v-button>
            <v-button v-if="!isEdit" :disabled="submitOrCancelBtnClick" @click="saveAndSubmit(0)">
              {{ $t('仅保存') }}
            </v-button>
            <v-button :disabled="submitOrCancelBtnClick" status="default" @click="callCancelDialog">
              {{ $t('取消') }}
            </v-button>
          </div>
        </div>
        <v-dialog v-model="cancelDialogShow" :title="$t('返回敏感词监控?')" kind="confirm" @confirm="cancel">
          <div>{{ $t('当前编辑的信息将不会保存。') }}</div>
          <span slot="confirm-text">{{ $t('返回') }}</span>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * form-item desc 自定义
 */
/* eslint-disable */
import utils from '@/common/utils';
import { Icon } from 'vhtml-ui';
import wordInput from './components/word-input';
import sensitiveDegreeEdit from './components/sensitive-degree-edit';
import selectStaffs from './components/select-staffs';
import urlTool from '@/utils/urlTool';
import '@/common/global.less';

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
const MONITOR_TYPES = [
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '与客户沟通',
    value: '1'
  },
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '与同事沟通',
    value: '2'
  },
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '群内沟通',
    value: '3'
  }
];
const SENSITIVE_ACTION_TYPE = [
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    text: '移除访客',
    value: 'Shanghai'
  },
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    text: '举报',
    value: 'Beijing'
  },
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    text: '屏蔽',
    value: 'Shenzhen'
  },
  {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    text: '企业级屏蔽客户',
    value: '12'
  }
]
const MAX_SENSITIVE_WORDS_NUM = 100;
const MAX_RULE_NAME_LENGTH = 50;
const SENSITIVE_DEGREE_INITIAL = '3';
const ruleNameFilterReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
export default {
  components: {
    wordInput,
    sensitiveDegreeEdit,
    selectStaffs
  },
  data() {
    let clientSideFlag = 1;
    // if (window?.data?.data) {
    //   clientSideFlag = window.data.data.clientSideFlag;
    // }
    return {
      MAX_SENSITIVE_WORDS_NUM,
      MAX_RULE_NAME_LENGTH,
      ruleName: '',
      sensitiveWords: [],
      monitorTypeArray: [],
      sensitiveDegreeRadio: SENSITIVE_DEGREE_INITIAL,
      isEdit: false,
      monitorTypes: MONITOR_TYPES,
      data: {},
      id: -1,
      staffSelected: [],
      staffOrgList: [],
      loading: true,
      ruleNameErr: false,
      sensitiveWordsErr: false,
      monitorTypesErr: false,
      staffSelectedErr: false,
      cancelDialogShow: false,
      isEdited: false,
      submitOrCancelBtnClick: false,
      sensitiveAction: SENSITIVE_ACTION_TYPE,
      currentType: parseInt(urlTool.getUrlParameter("currentType")) || 1,  //1:员工敏感词 ；2:员工敏感动作 ；3:客户敏感词
      sensitiveActionData: [],
      clientSideFlag: parseInt(clientSideFlag, 10) // 在白明单里 展示新页面，不在白名单里展示老页面
    };
  },
  watch: {
    ruleName(nextValue, oldValue) {
      this.contentEdited();
      this.$nextTick(function () {
        if (nextValue != '' && !ruleNameFilterReg.test(nextValue)) {
          this.ruleName = oldValue;
        }
      });
    },
    monitorTypeArray() {
      this.contentEdited();
    },
    sensitiveDegreeRadio() {
      this.contentEdited();
    }
  },
  computed: {
    getCurrentTitle() {
      const action = this.isEdit ? this.$t('编辑') : this.$t('新建');
      let title = this.$t('{action}规则', { action });
      if (this.clientSideFlag === 1) {
        const target = this.currentType === 3 ? this.$t('客户') : this.$t('员工');
        title = this.$t('{action}{target}敏感词规则', { action, target });
      }
      return title
    }
  },
  mounted() {
    this.getSensitiveRule();
    console.log(this.clientSideFlag, "clientSideFlag");

  },
  methods: {
    changeSelected() {
      console.log('我改变了嘛');
      this.submitOrCancelBtnClick = false;
      this.isEdited = true
      console.log(this.submitOrCancelBtnClick);
    },
    showSelect(res) {
      this.staffSelected = res;
    },
    showDepart(res) {
      this.staffOrgList = res
    },
    contentEdited() {
      if (!this.loading && !this.isEdited) this.isEdited = true;
    },
    staffSelectedChange(staffSelected) {
      this.contentEdited();
      this.staffSelected = staffSelected;
    },
    changeOrg(res) {
      this.staffOrgList = res;
      this.submitOrCancelBtnClick = false;
      this.isEdited = true
    },
    callCancelDialog() {
      this.cancelDialogShow = true;
    },
    sensitiveWordsChange(type, id, val) {
      this.contentEdited();
      switch (type) {
        case 'edit':
          this.sensitiveWords[id].mode = 'edit';
          break;
        case 'delete':
          this.sensitiveWords.splice(id, 1);
          break;
        case 'add':
          this.sensitiveWords.push({
            name: '',
            mode: 'edit',
            id
          });
          break;
        case 'done':
          this.sensitiveWords[id].name = val;
          this.sensitiveWords[id].mode = 'view';
          break;
        default:
          console.log('undefined input');
      }
    },
    getSensitiveRule() {
      const id = urlTool.getUrlParameter("id");
      let i;
      const self = this;
      // console.log(id);
      if (!id) {
        this.loading = false;
        return;
      }
      this.isEdit = true;
      this.id = id;
      let params = {
        id
      }
      if (this.clientSideFlag === 1) {
        if (this.currentType === 1) {
          params.side = 1;
        } else if (this.currentType === 3) {
          params.side = 2;
        }
      }

      this.$ajax.gatewayGet('/tp/sensitiveWords/getSensitiveWordsSet', params).then(
        data => {
          console.log(data);
            const sensitiveWords = [];
            this.data = data.data || {};
            // 先不管{}
            /**
             * sensitiveWords需要变形，由String[]改为Object[],增加单个sensitiveWord的编辑状态：查看view，编辑edit。这是为了保留get数据的""字段并显示。
             * 增加sensitiveWord id是为了保证在vue组件更新时不错乱，需要前端保证id的唯一性
             */
            this.ruleName = this.data.name;
            if (this.data.wordList) {
              this.data.wordList.forEach((sensitiveWord, index) => {
                sensitiveWords.push({
                  name: sensitiveWord,
                  mode: 'view',
                  id: index
                });
              });
            }
            this.sensitiveWords = sensitiveWords;
            for (i = 0; i < this.data.channelIds.length; i++) {
              this.monitorTypeArray.push(`${this.data.channelIds[i]}`);
            }
            this.sensitiveDegreeRadio = String(this.data.actionType);
            const tmpExistedStaff = []; // 防止传来的数据重复
            if (this.data.staffList) {
              this.data.staffList.forEach(item => {
                if (!tmpExistedStaff.includes(item.kfext)) {
                  tmpExistedStaff.push(item.kfext);
                  self.staffSelected.push({
                    ename: item.account,
                    // gender: parseInt(item.gender),
                    // icon: item.face,
                    id: String(item.kfext), // 强制转成string 类型
                    name: item.name,
                    gender: item.gender
                  });
                }
              });
            }
            const tmpExistedStaffOrgList = []; // 防止传来的数据重复
            if (this.data.orgList) {
              this.data.orgList.forEach(item => {
                if (!tmpExistedStaffOrgList.includes(item.FId)) {
                  tmpExistedStaffOrgList.push(item.FId);
                  self.staffOrgList.push({
                    id: item.FId,
                    name: item.FName,
                    total: item.membersTotal,
                    isFolder: true
                  });
                }
              });
            }
            /**
             * 这里增加nextTick是为了在编辑页面时，如果未编辑过，那么按钮置灰
             */
            this.$nextTick(function () {
              this.loading = false;
            });
        },
        error => {
          console.log(error);
          this.$message(error || this.$t('请求出错'), 'error');
        }
      );
    },
    sensitiveWordsHasUnview() {
      let i;
      /**
       * 如果敏感词编辑框里面存在处于编辑状态的敏感词，则阻止保存，首先提示该状态
       */
      for (i = 0; i < this.sensitiveWords.length; i++) {
        if (this.sensitiveWords[i].mode != 'view') return true;
      }
      return false;
    },
    initErrStatus() {
      this.ruleNameErr = false;
      this.sensitiveWordsErr = false;
      this.monitorTypesErr = false;
      this.staffSelectedErr = false;
    },
    checkBeforeSubmit() {
      let canSubmit = true;
      this.initErrStatus();
      if (!this.ruleName) {
        this.ruleNameErr = true;
        this.$nextTick(function () {
          this.$refs.ruleName.focus();
        });
        canSubmit = false;
      }
      if (this.ruleName.length > MAX_RULE_NAME_LENGTH) {
        this.$message(this.$t('规则名不得超过{n}个字符', { n: MAX_RULE_NAME_LENGTH }), 'error');
        this.ruleNameErr = true;
        canSubmit = false;
      }
      if (this.sensitiveWords.length == 0) {
        this.sensitiveWordsErr = true;
        canSubmit = false;
      }
      if (this.sensitiveWordsHasUnview()) {
        this.$message(this.$t('尚有处于编辑状态的敏感词'), 'error');
        canSubmit = false;
      }
      // 客户敏感词 放弃这里的校验
      if (this.clientSideFlag !== 1 || this.currentType !== 3) {
        if (this.monitorTypeArray.length == 0) {
          this.monitorTypesErr = true;
          canSubmit = false;
        }
      }
      if (this.staffSelected.length == 0 && this.staffOrgList == 0) {
        console.log(this.staffSelected);
        this.staffSelectedErr = true;
        canSubmit = false;
      }
      if (this.sensitiveDegreeRadio == '') {
        // 已设置初始值，不存在问题
        this.$message(this.$t('请选择告警程度'), 'error');
        canSubmit = false;
      }
      return canSubmit;
    },
    saveAndSubmit(status) {
      const { data } = this;
      const channelIds = [];
      const wordList = [];
      const monitoredUins = [];
      const monitoredOrgIds = [];
      let params;
      let reqUrl;

      if (!this.checkBeforeSubmit()) return;

      this.submitOrCancelBtnClick = true;
      // if (this.id == -1) return;
      this.monitorTypeArray.forEach(item => {
        channelIds.push(parseInt(item));
      });
      this.sensitiveWords.forEach(sensitiveWord => {
        wordList.push(sensitiveWord.name);
      });
      this.staffSelected.forEach(item => {
        monitoredUins.push(item.id);
      });
      this.staffOrgList.forEach(item => {
        monitoredOrgIds.push(item.id);
      });
      console.log('创建', this.staffOrgList)
      params = {
        name: this.ruleName,
        actionType: this.sensitiveDegreeRadio,
        channelIds,
        wordList,
        monitoredOrgIds,
        monitoredUins,
        status
      };
      if (this.clientSideFlag === 1) {
        let currentParams = Object.assign({}, params);
        // 员工敏感动作的时候有敏感动作类型
        if (this.currentType === 1) {
          currentParams.side = 1;
          params = currentParams;
        }
        // 敏感动作 暂时屏蔽
        // else if(this.currentType === 2) {
        //     currentParams.sensitiveAction = this.sensitiveActionData;
        //     delete currentParams.wordList;
        //     delete currentParams.channelIds;
        //     delete currentParams.actionType;
        //     params = currentParams;
        // }
        else if (this.currentType === 3) {
          delete currentParams.channelIds;
          currentParams.side = 2;
          params = currentParams;
        }
        console.log("改变以后的", params);
      }

      reqUrl = '/tp/sensitiveWords/create';
      if (this.id != -1) {
        params.id = this.id;
        reqUrl = '/tp/sensitiveWords/update';
      }
      this.$ajax.gatewayPost(reqUrl, params).then(
        data => {
          console.log(data);
          if (data.r == 0) {
            this.$message(this.$t('设置成功'), 'success');
            let url = '/tp/sensitiveWords';
            if (this.clientSideFlag === 1 && this.currentType === 3) {
              url = url + "?currentTab=client";
            }
            window.location.href = url;
          } else {
            this.submitOrCancelBtnClick = false;
            this.$message(data.message || this.$t('设置失败'), 'error');
          }
        },
        error => {
          console.log(error);
          this.submitOrCancelBtnClick = false;
          this.$message(error || this.$t('请求出错'), 'error');
        }
      );
    },
    cancel() {
      this.submitOrCancelBtnClick = true;
      let url = '/tp/sensitiveWords';
      console.log(this.currentType, this.clientSideFlag, "跳转前的currentType");

      if (this.clientSideFlag === 1 && this.currentType === 3) {
        url = url + "?currentTab=client";
      }
      window.location.href = url;
    },
    createRule() {
      console.log(this.sensitiveActionData);

    }
  }
};
</script>

<style lang="less">
@import './styles/app';
</style>
